import { useMemo, useState } from "react";
import { useGetInterviewTypeData } from "../Hooks/AssesmentHooks";
import aidynamicimage from "././../Assets/Icons/ai_dynamic.jpg";
import bigfiveimage from "././../Assets/Icons/bigfive_personality.jpg";
import { useNavigate } from "react-router-dom";
const PendingAssessment = () => {
  const user_id = localStorage.getItem("candidate");
  const navigate = useNavigate();

  const {
    data: interviewTypesData,
    status: interviewTypesDataStatus,
    refetch: refetchinterviewTypeData,
    isLoading: loadingInterviewTypeData,
    isFetching: fetchingInterviewTypeData,
  } = useGetInterviewTypeData({
    params: {},
    enabled: !!user_id,
  });

  // const pending_assessments = interviewTypesData?.interviews_payment_details?.filter((item) => item.status == "PAID" && !item?.attended_status);

  const pending_assessments = useMemo(() => {
    return interviewTypesData?.interviews_payment_details?.filter(
      (item) => item.status === "PAID" && !item?.attended_status
    );
  }, [interviewTypesData]);

  return (
    <div className="w-full  h-[700px] bg-white shadow-lg rounded-xl p-6 sm:p-8 overflow-y-auto mt-4">
      <div className="flex flex-col px-4 py-10 mx-auto p-7">
        <div className="w-full py-8">
          <div className="flex flex-wrap justify-center gap-8 mx-auto max-w-9xl ">
            {pending_assessments?.length === 0 ? (
              <div className="w-full flex items-center justify-center">
                <h3>No Pending Assessment</h3>
              </div>
            ) : (
              pending_assessments?.map((item) => (
                <div className="shadow-md hover:shadow-lg rounded-sm overflow-hidden bg-white w-full sm:w-[300px] md:w-[400px] lg:w-[430px] p-3">
                  <img
                    src={
                      item?.interview_type === "Master Your Interview"
                        ? aidynamicimage
                        : bigfiveimage
                    }
                    alt="AI Dynamic Interview"
                    className="object-cover w-full h-80"
                  />
                  <div className="p-4">
                    <h3 className="mb-2 text-lg font-semibold">
                      {item?.interview_type}
                    </h3>
                    <p className="mb-4 text-sm text-gray-600">
                      {item?.description}
                    </p>

                    <div className="flex items-center justify-between">
                      <button className="bg-[#1229fa] p-2 px-8 text-white font-bold rounded-md">
                        Start Interview
                      </button>

                      <span className="text-xl font-bold">₹{item?.fee}</span>
                    </div>
                  </div>
                </div>
              ))
            )}
            {/* {pending_assessments?.map((item) => (
              <>
                {item?.status === "PAID" ? (
                  <div className="shadow-md hover:shadow-lg rounded-sm overflow-hidden bg-white w-full sm:w-[300px] md:w-[400px] lg:w-[430px] p-3">
                    <img
                      src={
                        item?.interview_type === "Master Your Interview"
                          ? aidynamicimage
                          : bigfiveimage
                      }
                      alt="AI Dynamic Interview"
                      className="object-cover w-full h-80"
                    />
                    <div className="p-4">
                      <h3 className="mb-2 text-lg font-semibold">
                        {item?.interview_type}
                      </h3>
                      <p className="mb-4 text-sm text-gray-600">
                        {item?.description}
                      </p>

                      <div className="flex items-center justify-between">
                        <button className="bg-[#1229fa] p-2 px-8 text-white font-bold rounded-md">
                          Start Interview
                        </button>

                        <span className="text-xl font-bold">₹{item?.fee}</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="w-full flex items-center justify-center">
                    <h3>No Pending Assessment</h3>
                  </div>
                )}
              </>
            ))} */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default PendingAssessment;
